import { FormSection } from "~components/Form/FormSection";
import { FormSkeleton } from "~components/Form/FormSkeleton";
import { StyledEntrantSection } from "../../styles";
import { SkeletonContainer, StyledTitleSkeleton } from "./FixtureEntrantsSkeleton.styles";

export const FixtureEntrantsSkeleton = () => {
  const column = (
    <div>
      <FormSection title={<StyledTitleSkeleton active size="small" />} />
      <StyledEntrantSection>
        {Array(6)
          .fill("")
          .map((_, index) => (
            // biome-ignore lint/suspicious/noArrayIndexKey: it's ok to have index as a key in this case
            <div key={index}>
              <FormSkeleton />
            </div>
          ))}
      </StyledEntrantSection>
    </div>
  );

  return (
    <SkeletonContainer>
      {column}
      {column}
    </SkeletonContainer>
  );
};
